module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_nia.d88374202c40352cbdfc12f4f09d9c78.png";